import Vue from 'vue';
import { ActivePopupTypes } from '@/store/modules/popup/types';
export default Vue.extend({
    name: 'whitelistsAhead',
    props: {
        itemsLength: {
            type: Number,
            required: true
        },
        selectedItems: {
            type: Array,
            required: true
        },
        addressesShows: {
            type: Boolean,
            required: true
        },
        letMultiEditNetworks: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        searchPhrase: '',
        showAddresses: false,
        codeError: false
    }),
    watch: {
        addressesShows(v) {
            this.showAddresses = v;
        },
        searchPhrase(newValue) {
            if (!newValue.length)
                this.$emit('onChangeSearchField', '');
        }
    },
    methods: {
        handleShowAddressesChange() {
            const vm = this;
            setTimeout(() => {
                if (vm.showAddresses) {
                    vm.showAddresses = false;
                    vm.$store.dispatch('popupModule/openPopup', {
                        type: ActivePopupTypes.action,
                        letDefaultClose: true,
                        title: vm.$t('whitelistsPage.popups.titles.confirmOperation'),
                        content: vm.$t('whitelistsPage.popups.content.enterSecretCodeToAppearAddress'),
                        slot: {
                            name: 'confirmActionPopupChunk',
                            data: {},
                            on: {
                                onConfirm(secret) {
                                    const haveError = secret.length < 2;
                                    vm.$store.commit('popupModule/setClosed');
                                    if (haveError) {
                                        vm.codeError = true;
                                        vm.handleShowAddressesChange();
                                    }
                                    else {
                                        vm.$emit('toggleShowAllAddresses', secret);
                                    }
                                },
                                onClickBeginReset() { vm.$emit('onClickBeginReset'); }
                            }
                        }
                    });
                }
                else {
                    vm.$emit('toggleShowAllAddresses');
                }
            }, 0);
        },
        handleClickDeleteAddress() {
            const vm = this;
            vm.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: vm.$t('whitelistsPage.popups.titles.confirmOperation'),
                content: vm.$t('whitelistsPage.popups.content.enterSecretCodeToDeleteAddress'),
                slot: {
                    name: 'confirmActionPopupChunk',
                    data: {},
                    on: {
                        onConfirm(secret) {
                            vm.$store.commit('popupModule/setClosed');
                            vm.$emit('onDeleteAddress', secret);
                        },
                        onClickBeginReset() { vm.$emit('onClickBeginReset'); }
                    }
                }
            });
        },
        toggleAddressVisibility() {
            const vm = this;
            if (vm.selectedItems[0].addressVisible) {
                vm.$emit('onToggleAddressVisibility', { id: vm.selectedItems[0].id, secret: '' });
            }
            else {
                vm.$store.dispatch('popupModule/openPopup', {
                    type: ActivePopupTypes.action,
                    letDefaultClose: true,
                    title: 'Подтверждение операции',
                    content: `Чтобы увидеть адрес "${vm.selectedItems[0].name}", введите секретный код от белого списка адресов`,
                    slot: {
                        name: 'confirmActionPopupChunk',
                        data: {},
                        on: {
                            onConfirm(secret) {
                                const haveError = secret.length < 2;
                                vm.$store.commit('popupModule/setClosed');
                                if (haveError) {
                                    vm.codeError = true;
                                    vm.toggleAddressVisibility();
                                }
                                else {
                                    vm.$emit('onToggleAddressVisibility', { id: vm.selectedItems[0].id, secret });
                                }
                            },
                            onClickBeginReset() { vm.$emit('onClickBeginReset'); }
                        }
                    }
                });
            }
        }
    }
});
